import { useFormik, FormikProps } from 'formik';
import { FormikValues } from 'formik/dist/types';
import {
  SyncRuleDto,
  SyncRuleTransform,
} from '../../../../services/redux/api/syncApi';

export function useSyncRuleForm(
  rule: SyncRuleDto | null | undefined,
  onClose: () => void,
  onSubmitExternal: (values: {
    provider: string;
    entity: string;
    sourcePath?: string | null;
    defaultValue?: string | null;
    localPath: string;
    prefix?: string | null;
    transform?: SyncRuleTransform | null;
  }) => void,
) {
  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    initialValues: {
      provider: rule?.provider ?? '',
      entity: rule?.entity ?? '',
      sourcePath: rule?.sourcePath ?? '',
      defaultValue: rule?.defaultValue ?? '',
      localPath: rule?.localPath ?? '',
      prefix: rule?.prefix ?? '',
      transform: rule?.transform ?? 'none',
    },
    onSubmit: onSubmit,
  });

  function onSubmit(values: FormikValues) {
    onSubmitExternal({
      provider: values.provider,
      entity: values.entity,
      sourcePath: values.sourcePath || null,
      defaultValue: values.defaultValue || null,
      localPath: values.localPath,
      prefix: values.prefix || null,
      transform: (values.transform as SyncRuleTransform) || null,
    });
  }

  return {
    formik,
    isSubmitting: formik.isSubmitting,
  };
}
